import { Navigate, useNavigate } from 'react-router-dom';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useApi } from '@/lib/api';
import { Card, PageHeader } from '@/components/ui';
import { OrgForm } from '@/components/org-form';
import { useOrgContext } from './layout';

export function NewChildOrgPage() {
  const { org, canManage } = useOrgContext();
  const api = useApi();
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const create = useMutation({
    mutationFn: (input: Parameters<typeof api.createChild>[1]) => api.createChild(org.id, input),
    onSuccess: (child) => {
      queryClient.invalidateQueries({ queryKey: ['children', org.id] });
      queryClient.invalidateQueries({ queryKey: ['usage'] });
      queryClient.invalidateQueries({ queryKey: ['myOrgs'] });
      navigate(`/organizations/${child.id}`);
    },
  });
  if (!canManage) return <Navigate to=".." replace />;

  return (
    <div className="max-w-3xl">
      <PageHeader
        title="Add a child organization"
        description={`An affiliated college, department or team under ${org.name}. It shares ${org.name}'s plan, and you'll be its owner.`}
        back={{ to: `/organizations/${org.id}/children`, label: 'Child organizations' }}
      />
      <Card>
        <OrgForm
          idPrefix="child"
          submitLabel="Add child organization"
          defaultType={org.type}
          pending={create.isPending}
          error={create.error}
          onSubmit={(input) => create.mutate(input)}
        />
      </Card>
    </div>
  );
}
